import Vue from 'vue';
import Vuex from 'vuex';
import SecureLS from 'secure-ls';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import config from '../api/httpConfig';
import http from '../utils/request'
import { loginWebIm } from '../utils/WebIM'
import request from "../utils/request";
Vue.use(Vuex);
var ls = new SecureLS({
  encodingType: 'aes', // 加密类型
  isCompression: false,
  encryptionSecret: 'encryption', // PBKDF2值
});
const data = {
  state: {
    access_token: '', // 暂存token
    classList: [], // 班级列表
    currentGroupId: '',
    currentGroupMess: {},
    folderList: [], // 文件夹列表
    groupLists: [],
    isBookBuy: true,
    msgList: [], // 班级聊天信息
    msgGroupList: [], // 群组聊天信息
    myBookList: [],
    styleId: 2,
    userId: '', // 暂存UserId
    userInfo: {},
    userPhoto: '',
    loadingState: false,
    taskFeedBackMess: {} // 任务反馈信息
  },
  plugins: [
    createPersistedState({
      // key: "encryptionStore",
      // storage: {
      //     getItem: (key) => ls.get(key),
      //     setItem: (key, value) => ls.set(key, value),
      //     removeItem: (key) => ls.remove(key),
      // },
      storage: window.localStorage,
      reducer(val) {
        return {
          // 只储存state中的assessmentData
          access_token: val.access_token,
          classList: val.classList,
          currentGroupId: val.currentGroupId,
          currentGroupMess: val.currentGroupMess,
          folderList: val.folderList,
          groupLists: val.groupLists,
          isBookBuy: val.isBookBuy,
          msgGroupList: val.msgGroupList,
          msgList: val.msgList,
          myBookList: val.myBookList,
          styleId: val.styleId,
          userId: val.userId,
          userInfo: val.userInfo,
          userPhoto: val.userPhoto,
          loadingState: val.loadingState,
          taskFeedBackMess: val.taskFeedBackMess
        };
      },
    }),
  ],
  getters: {
    isBookBuy: function(state) {
      return state.isBookBuy;
    },
    styleId: function(state) {
      return state.styleId;
    },
    userPhoto: function(state) {
      return state.userPhoto;
    },
    userInfo: function(state) {
      return state.userInfo;
    },
    msgList: function(state) {
      return state.msgList;
    },
    msgGroupList: function(state) {
      return state.msgGroupList;
    },
    groupLists: function(state) {
      return state.groupLists;
    },
    // 班级列表
    classList: function(state) {
      return state.classList;
    },
    // 根据当前班级id或者班级信息
    currentClass: function(state) {
      const curClass = state.classList.filter(
        (c) => c.id === state.currentClassId
      );
      return curClass[0];
    },
  },
  actions: {
    // 如果班级列表为空，获取班级列表
    getClassList(context) {
      if (context.state.classList.length > 0) return;
      axios({
        url: config.$getTeaClassListByUserId,
        method: 'post',
        data: {
          access_token: context.state.access_token,
          userId: context.state.userId,
        },
        headers: { 'Content-Type': 'application/json' },
      }).then((res) => {
        if (res) {
          context.commit('setClassList', res);
          context.commit('setCurrentClassId', res[0].id);
        }
      });
    },
    setLoadingState ({ commit}, boolean) {
      // commit('SET_LOADING', boolean)
    }
  },
  mutations: {
    setGroupLists(state, groupLists) {
      Vue.set(state, 'groupLists', groupLists);
    },
    setCurrentClassId(state, currentClassId) {
      Vue.set(state, 'currentClassId', currentClassId);
    },
    setCurrentGroupId(state, currentGroupId) {
      Vue.set(state, 'currentGroupId', currentGroupId);
    },
    setCurrentGroupMess(state, currentGroupMess) {
      Vue.set(state, 'currentGroupMess', currentGroupMess);
    },
    setMsgGroupList(state, msgGroupList) {
      Vue.set(state, 'msgGroupList', msgGroupList);
    },
    setMsgList(state, msgList) {
      Vue.set(state, 'msgList', msgList);
    },
    setUser_Info(state, userInfo) {
      Vue.set(state, 'userInfo', userInfo);
    },
    setUserPhoto(state, userPhoto) {
      Vue.set(state, 'userPhoto', userPhoto);
    },
    setMyBookList(state, myBookList) {
      Vue.set(state, 'myBookList', myBookList);
    },
    setIsBookBuy(state, isBookBuy) {
      Vue.set(state, 'isBookBuy', isBookBuy);
    },
    setStyleId(state, styleId) {
      Vue.set(state, 'styleId', styleId);
    },
    setFolderList(state, folderList) {
      Vue.set(state, 'folderList', folderList);
    },
    setClassList(state, classList) {
      Vue.set(state, 'classList', classList);
    },
    setAccessToken(state, accessToken) {
      Vue.set(state, 'access_token', accessToken);
    },
    setUserId(state, userId) {
      Vue.set(state, 'userId', userId);
    },
    setTaskFeedBackMess (state, taskFeedBackMess) {
      Vue.set(state, 'taskFeedBackMess', taskFeedBackMess)
    }
  },
};

export default new Vuex.Store(data);
